import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)


export const routes = [
    {
        path: '/',
        component: () => import('@/views/index'),    
    },
    {
        path: '/artist',
        component: () => import('@/views/Artist/index'),    
    },
    {
        path: '/artist/artistInfo/:artistId(\\d+)',
        component: () => import('@/views/Artist/artistInfo'),    
    },
    // {
    //     path: '/artist/artistProduct/1',
    //     component: () => import('@/views/Artist/artistProduct'),    
    // },
    {
        path: '/exhibition',
        component: () => import('@/views/Exhibition/index'),    
    },
    {
        path: '/exhibition/exhibitionInfo/:exhibitionId(\\d+)',
        component: () => import('@/views/Exhibition/exhibitionInfo'),    
    },
    {
        path: '/exhibition/exhibitionOpus/:exhibitionId(\\d+)',
        component: () => import('@/views/Exhibition/exhibitionOpus'),    
    },
    {
        path: '/fairs',
        component: () => import('@/views/Fairs/index'),    
    },
    {
        path: '/fairs/fairsInfo/:fairsId(\\d+)',
        component: () => import('@/views/Fairs/fairsInfo'),    
    },
    {
        path: '/fairs/fairsOpus/:fairsId(\\d+)',
        component: () => import('@/views/Fairs/fairsOpus'),    
    },
    {
        path: '/fov',
        component: () => import('@/views/Fov/index'),    
    },
    {
        path: '/fov/fovInfo/:fovId(\\d+)',
        component: () => import('@/views/Fov/fovInfo'),    
    },
    {
        path: '/about',
        component: () => import('@/views/About/index'),    
    },
    {
        path: '/search',
        component: () => import('@/views/Search/index'),    
    },
    {
        path: '*',
        redirect:'/'
    },
]




export default new Router({
    mode: 'history', // 去掉url中的#
    routes
})

